import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_WaiverOfLiability = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_WaiverOfLiability' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Home Health Agency</h3></p>
                <p className='w-750'><h3>Waiver of Liability</h3></p>

                <p className='w-750'>
                    1. In consideration for receiving mental health counseling at Lilly Pad 
                    Home Health, LLC. I hereby release, waive, discharge and convenant not to sue 
                    Lilly Pad Home Health, LLC, officers, agents, servants, or employees (hereinafter referred to as releasees) 
                    from any and all liability, claims, demands, actions and causes of action whatsoever arising out of or related to 
                    any loss, damage, or injury, including death, that may be sustained by me, or any of the property belonging to me, 
                    whether caused by the negligence of the releasees, or otherwise, while participating in such services or while in, 
                    on, or upon the premises where the services are conducted.
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    2. I am dully aware of the risks involved, and I hereby elect to voluntarily 
                    participate in mental heath counseling and community support with full knowledge 
                    that said services may be hazardous to me and my property. I voluntarily assume full responsibility for any 
                    risks of loss, property damage or personal injury, including death, that may be sustained by me, or any loss or 
                    damage to property owned by me, as a result of being engaged in such services, whether caused by the negligence of releasees or otherwise.
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    3. I further hereby agree to indemnify and hold harmless the releasees from 
                    any loss, liability, damage, or costs, including courts costs and attorney fees,
                     that they may incur due to my participation in said services, whether caused by negligence of releasees or otherwise.
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    4. It is express intent that this Waiver of Liability and Hold Harmless 
                    Agreement shall bind the members of my family and spouse, if I am alive, and 
                    my heirs, assigns and personal representative, if I am decreased, and shall be deemed as a release, waiver, 
                    discharge, and convenant not to sue the above-named releasees. I hereby further agree that this Waiver of Liability 
                    and Hold Harmless Agreement shall be construed in accordance with Waiver of Liability and Hold Harmless Agreement shall 
                    be construed in accordance with the laws of the State of Louisiana.
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    5. In signing this release, I acknowledge and represent that I have read 
                    the foregoing Waiver of Liability and Hold Harmless Agreement, understand it 
                    and sign it voluntarily as my own free act and deed; no oral representations, statements, or inducements, 
                    apart from the foregoing written agreement, have been made; I am at least eighteen (18) years of age and fully 
                    competent; and I execute this release for full, adequate and complete considereation fully intending to be bound by same.
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    In witness whereof, I have hereunto set my hand and seal on this &nbsp;
                    <input type='text' name='txtMedicatio' id='txtMedicatio' className='add-only w-250 custom-add-only' /> &nbsp;
                    day of in the year 20
                </p>

                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-750'>Client Signature
                        </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











